"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ripple_address_codec_1 = __importDefault(require("ripple-address-codec"));
var utils = __importStar(require("../utils"));
var computed = __importStar(require("../computed"));
function Decode(encodedDestination) {
    var codecOptions = computed.CodecOptions(encodedDestination);
    var decoded = ripple_address_codec_1.default.codecs.ripple.decode(encodedDestination, codecOptions);
    var hex = utils.toHex(decoded);
    var accountHex = hex.slice(0, 40);
    var tagTypeHex = hex.slice(40, 42);
    var tagHex = hex.slice(42, 58);
    return {
        account: ripple_address_codec_1.default.encodeAddress(utils.toBytes(accountHex)),
        tag: tagTypeHex === '01'
            ? String(utils.uInt32LE_ToUInt32(tagHex))
            : null,
        test: computed.IsTest(encodedDestination)
    };
}
exports.default = Decode;
